import { useDealsStore } from '../../store/deals';
import { useUIStore } from '../../store/ui';
import type { DealStage } from '../../types';

const STAGE_DOT: Record<DealStage, string> = {
  intake: 'intake',
  title: 'research',
  package: 'package',
  pitching: 'pitching',
  closed: 'closed',
};

export function TabBar() {
  const deals = useDealsStore(s => s.deals);
  const openTabs = useUIStore(s => s.openTabs);
  const activeDealId = useUIStore(s => s.activeDealId);
  const setActive = useUIStore(s => s.setActive);
  const closeDeal = useUIStore(s => s.closeDeal);
  const setShowDealIndex = useUIStore(s => s.setShowDealIndex);

  return (
    <div className="tabbar">
      <button className="tab-deals-btn" onClick={() => setShowDealIndex(true)}>
        <span className="icon">▤</span>
        <span>All deals · {deals.length}</span>
      </button>
      {openTabs.map(t => {
        const deal = deals.find(d => d.id === t.dealId);
        if (!deal) return null;
        const active = activeDealId === t.dealId;
        return (
          <div
            key={t.dealId}
            className={`tab ${active ? 'active' : ''}`}
            onClick={() => setActive(t.dealId)}
          >
            <span className={`tab-status-dot ${STAGE_DOT[deal.stage]}`}></span>
            <span className="tab-name">
              {deal.ownerName.split(' ').slice(-1)[0].toUpperCase()} — {deal.trs}
            </span>
            <button
              className="tab-close"
              onClick={e => { e.stopPropagation(); closeDeal(t.dealId); }}
              aria-label="Close tab"
            >×</button>
          </div>
        );
      })}
      <button className="tab-new" onClick={() => setShowDealIndex(true)} aria-label="New tab">+</button>
    </div>
  );
}
